export default __webpack_public_path__ + "f2500da3045647144e7b25f3bf38d0b3.jpg";